import { SystemAuthorizations } from 'shell/authorizations/system';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.TipoFeatureAuthQuery],
  create: [SystemAuthorizations.TipoFeatureAuthAdd],
  edit: [SystemAuthorizations.TipoFeatureAuthUpdate],
  delete: [SystemAuthorizations.TipoFeatureAuthDelete],
});
